<template>
  <div>
    <footer
      class="footer bg-me-primary"
      :class="this.footer == 'footer-dark' ? 'footer-dark' : ''"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright  text-center">
            <span class="copyright">Copyright 2025 © Motion Energy</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import json from "../data/menu";
import { mapGetters } from "vuex";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "footerpage",
  data() {
    return {
      customizer: false,
      data:
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(json)),
    };
  },
  computed: {
    ...mapGetters({
      footer: "layout/footer",
    }),
  },
};
</script>
